import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Zap } from "lucide-react";

const money = (n) => "$" + Number(n).toLocaleString("es-MX");

export default function VehiculoModal({ vehiculo, onClose, onPrecal }) {
  const open = !!vehiculo;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent
        data-testid="veh-modal"
        className="max-w-2xl border-af-border-dark p-0 overflow-hidden"
        style={{ background: "var(--af-black-soft)", color: "#fff" }}
      >
        {vehiculo && (
          <div>
            <DialogTitle className="sr-only">{vehiculo.marca} {vehiculo.modelo} {vehiculo.version}</DialogTitle>
            <img src={vehiculo.imagen} alt={vehiculo.modelo} className="w-full object-cover" style={{ height: 260 }} />
            <div className="p-6">
              <div className="text-white/50 text-xs uppercase tracking-wide">{vehiculo.marca} · {vehiculo.tipo} · {vehiculo.anio}</div>
              <h3 className="text-white font-bold text-2xl">{vehiculo.modelo} <span className="text-white/60 text-lg font-normal">{vehiculo.version}</span></h3>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-5">
                {[
                  ["Precio Autofinanza", money(vehiculo.precio_autofinanza), true],
                  ["Precio de lista", money(vehiculo.precio_lista), false],
                  ["Ahorro", `${vehiculo.porcentaje_ahorro}%`, false],
                  ["Enganche estimado", money(vehiculo.enganche_estimado), false],
                  ["Mensualidad desde", money(vehiculo.mensualidad_desde), false],
                  ["Plazo", `${vehiculo.plazo} meses`, false],
                ].map(([k, v, hl]) => (
                  <div key={k} className="rounded-lg p-3" style={{ background: "#111", border: "1px solid var(--af-border-dark)" }}>
                    <div className="text-white/50 text-xs">{k}</div>
                    <div className={`font-semibold ${hl ? "text-af-orange-core text-lg" : "text-white"}`}>{v}</div>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-1.5 mt-4">
                {vehiculo.modalidades_disponibles?.map((m) => (
                  <span key={m} className="text-xs text-white/70 px-2 py-1 rounded border border-af-border-dark">{m}</span>
                ))}
              </div>

              <button data-testid="veh-modal-precal" onClick={() => { onClose(); onPrecal(vehiculo); }}
                className="af-btn-primary w-full mt-6">
                <Zap size={18} /> Iniciar precalificación
              </button>
              <p className="text-white/45 text-xs mt-3">La aprobación y condiciones finales dependen de la institución correspondiente.</p>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
